import type { paths } from "@securityjourney/svc-idp/dist/gen/idp.d.ts";

import {
  AuthenticateWithCodeRequest,
  PasswordAuthenticateRequest,
  RedirectRequest,
  RegisterUserRequest,
} from "./idpTypes";
import { OpenApiFetchWrapper } from "../openApiFetchWrapper";

export class LoginClient extends OpenApiFetchWrapper<paths> {
  constructor() {
    super({ noAuth: true });
  }

  // Called prior to login to figure out if the user should be redirected to an IDP based on their email domain
  async redirect(req: RedirectRequest) {
    return await this.post("/svc/idp/redirect-url", { body: req });
  }

  // Step 1 of password authentication flow - get a nonce to include in the password auth request
  async generateAuthNonce() {
    return await this.post("/svc/idp/auth/nonce");
  }

  // Step 2 of password authentication flow - exchange email, password, and nonce for authentication cookie
  async passwordAuthenticate(req: PasswordAuthenticateRequest) {
    return await this.post("/svc/idp/auth/password", { body: req });
  }

  // SAML authentication flow - exchange code from IDP for authentication cookies
  async authenticateWithCode(req: AuthenticateWithCodeRequest) {
    return this.get("/svc/idp/auth/exchange", { params: { query: req } });
  }

  // If the Cognito ID token has expired, this endpoint gets a new one
  async refreshToken() {
    return await this.post("/svc/idp/auth/refresh", { body: {}, credentials: "include" });
  }

  // Register a new user with email and password
  async register(req: RegisterUserRequest) {
    return await this.post("/svc/idp/auth/register", { body: req });
  }
}
